function updateFreeShippingBox(domPlace) {
  const $container = $(domPlace);
var cartInfo = getShoptetDataLayer("cartInfo");

  /*if (!cartInfo || cartInfo.freeShippingFrom) {
    $container.find(".row-free-shipping").remove();
    return;
  }*/
  if (!$container.find(".row-free-shipping").length) {
    $container.append(`
        <tr class="row-free-shipping">
          <td >
            <div id="freeShippingBox">
              <div id="freeShippingText">
                <p class="left"></p>
              </div>
              <div id="freeShippingBar">
                <span class="bar"></span>
              </div>
              <span class="freeShippingAmounts" id="freeShippingAmounts"></span>
            </div>
          </td>
        </tr>
        `);
  }

  

  //if (!cartInfo || !cartInfo.freeShipping) return;
  var freeShippingLimit = freeShipping;
  var currentValue = cartInfo.getNoBillingShippingPrice.withVat; // kolik chybí
  var totalLeft = parseFloat(freeShippingLimit) - parseFloat(currentValue); // kolik už máš
  var progressPercent = 0;
  currentValue = Math.abs(parseFloat(currentValue));
  totalLeft = Math.max(0, totalLeft); // pro jistotu, kdyby vyšlo záporné

  if (cartInfo.cartItems.length === 0) {
    progressPercent = 0;
    currentValue = freeShippingLimit;
  } else if (currentValue <= 0) {
    progressPercent = 100;
  } else {
    progressPercent =
      100 - Math.round((totalLeft / freeShippingLimit) * 100);
    if (progressPercent > 100) progressPercent = 100;
  }



  if (currentValue > freeShippingLimit) {
    var cartItems = getShoptetDataLayer("cart");

    // máš dopravu zdarma a něco v košíku
    $("#freeShippingText .left").html("<strong>Máte dopravu zdarma!</strong>");
    $("#freeShippingBar .bar").css("width", "100%");
  } else {
    $("#freeShippingText .left").html(
      "Nakup už <strong>jen za " +
      Number(totalLeft).ShoptetFormatAsCurrency() +
      "</strong> a získej <strong>dopravu zdarma!</strong>",
    );
  }

  $(".freeShippingAmounts").html(
    Number(currentValue).ShoptetFormatAsCurrency() +
    " / <strong>" +
    Number(freeShippingLimit).ShoptetFormatAsCurrency() +
    "<strong>",
  );
  $("#freeShippingBar .bar").css("width", progressPercent + "%");

}
